import { createEntityAdapter } from "@reduxjs/toolkit";

import type { CardLimitEntity } from "./types";

// CardLimitEntity already has an `id` field so it's not necessary to pass selectId
export const cardLimitsEntityAdapter = createEntityAdapter<CardLimitEntity>();
